import { render, staticRenderFns } from "./IVRselectActionsModal.vue?vue&type=template&id=26c7d425&"
import script from "./IVRselectActionsModal.vue?vue&type=script&lang=js&"
export * from "./IVRselectActionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports